/* global AFRAME */

AFRAME.registerComponent('toggle-video-mute', {
  schema: {
    on: {type: 'string'},
    target: {type: 'selector'},
  },

  init: function () {
    var data = this.data;
    var el = this.el;

    el.addEventListener(data.on, function () {
      var src = data.target.getAttribute('src');
      var video = document.querySelector(src);
      video.muted = !video.muted;
      var attr = video.getAttribute('muted');
      video.setAttribute('muted', !attr);
    });
  },
});




// WEBPACK FOOTER //
// ./js/components/toggle-video-mute.js